(function () {
  'use strict';
  if (window.__easelExperienceInstalled) return;
  window.__easelExperienceInstalled = true;
  var api = 'https://platform.arthaus.cloud/easel';
  var host = 'https://www.taudalpoi.art';
  var pending = window.__easelDiscoveryPending || (window.__easelDiscoveryPending = new Map());
  function valid(value) {
    if (value && value.schemaVersion === 'easel-gallery-availability/v1') return typeof value.available === 'boolean' && value.artistId === '532' && /^\d+$/.test(value.artworkId);
    return value && value.schemaVersion === 'easel-experience-availability/v1' && typeof value.available === 'boolean' &&
      (!value.available || (value.artistId === '532' && /^\d+$/.test(value.artworkId) && value.experienceId === 'storefront' && /^[A-Za-z0-9_-]{1,80}$/.test(value.releaseId)));
  }
  function discover(handle) {
    var url = api + '/products/by-handle/' + encodeURIComponent(handle) + '/experience';
    var key = 'easel-discovery-v2:' + url;
    try {
      var cached = JSON.parse(localStorage.getItem(key) || 'null');
      if (cached && cached.expires > Date.now() && valid(cached.value)) return Promise.resolve(cached.value);
    } catch (_) { /* Storage is optional. */ }
    if (pending.has(key)) return pending.get(key);
    var task = fetch(url, { signal: AbortSignal.timeout(8000) }).then(function (response) {
      if (!response.ok) throw new Error('Experience discovery unavailable');
      return response.json();
    }).then(function (value) {
      if (!valid(value)) throw new Error('Invalid experience availability');
      if (value.available || value.artistId !== '532' || !/^\d+$/.test(value.artworkId)) return value;
      return fetch(host + '/api/gallery/' + value.artworkId, { signal: AbortSignal.timeout(8000) }).then(function (response) {
        if (!response.ok) throw new Error('Gallery discovery unavailable');
        return response.json();
      }).then(function (gallery) {
        if (!valid(gallery) || gallery.artworkId !== value.artworkId) throw new Error('Invalid gallery availability');
        return gallery;
      });
    }).then(function (value) {
      if (!valid(value)) throw new Error('Invalid experience availability');
      try { localStorage.setItem(key, JSON.stringify({ value: value, expires: Date.now() + (value.available ? 300000 : 60000) })); } catch (_) {}
      return value;
    }).finally(function () { pending.delete(key); });
    pending.set(key, task);
    return task;
  }
  function activate(node, value) {
    function labelButton(control) {
      var icon = node.querySelector('template[data-easel-icon]');
      if (icon) control.append(icon.content.cloneNode(true));
      var label = document.createElement('span');
      label.textContent = node.dataset.easelLabel || 'View Artwork';
      control.append(label);
    }
    var button = document.createElement('button');
    button.type = 'button'; button.className = 'easel-experience__button';
    labelButton(button); button.setAttribute('aria-haspopup', 'dialog');
    function openExperience(trigger) {
      var emit = window.ahExperienceAnalytics ? window.ahExperienceAnalytics.create({ title: node.dataset.easelTitle || 'Artwork experience',
        product_id: (window.__ahAnalytics && window.__ahAnalytics.product || {}).id, handle: node.dataset.easelHandle,
        artwork_id: value.artworkId, experience_id: value.experienceId, release_id: value.releaseId, entry_point: 'immersive_cta' }) : function () {};
      var dialog = document.createElement('dialog');
      dialog.className = 'easel-experience__dialog'; dialog.setAttribute('aria-label', node.dataset.easelTitle || 'Artwork experience');
      var header = document.createElement('div'); header.className = 'easel-experience__header';
      var title = document.createElement('span'); title.className = 'easel-experience__title'; title.textContent = node.dataset.easelTitle || 'Artwork experience';
      var close = document.createElement('button'); close.type = 'button'; close.className = 'easel-experience__close'; close.textContent = '\u00d7'; close.setAttribute('aria-label', 'Close experience');
      var frame = document.createElement('iframe'); frame.className = 'easel-experience__frame'; frame.title = node.dataset.easelTitle || 'Artwork experience';
      frame.allow = 'camera; autoplay; fullscreen; accelerometer; gyroscope'; frame.allowFullscreen = true;
      frame.src = host + '/embed/gallery/' + value.artworkId;
      frame.referrerPolicy = 'origin';
      function configure(event) {
        if (event.origin !== host || event.source !== frame.contentWindow || !event.data || event.data.type !== 'easel-rooms-ready-v1') return;
        var root = scope.querySelector('[data-hd-scale-scene]');
        if (root && root._ahRoomsConfig) {
          var config = root._ahRoomsConfig(true);
          // WebGL textures require CORS; the embed host's allowlisted image service is same-origin.
          if (config) {
            var artwork = new URL('/artwork-ms/api/internal/artworks/' + value.artworkId + '/display', api);
            artwork.searchParams.set('width', '1200');
            config.poster = host + '/_next/image?url=' + encodeURIComponent(artwork.href) + '&w=1200&q=75';
          }
          frame.contentWindow.postMessage(config, host);
        }
      }
      window.addEventListener('message', configure);
      var removeBridge = window.ahExperienceAnalytics ? window.ahExperienceAnalytics.bridge(frame, emit) : function () {};
      close.addEventListener('click', function () { dialog.close(); });
      var overflow = document.body.style.overflow;
      dialog.addEventListener('close', function () { emit({ action: 'close' }); window.removeEventListener('message', configure); removeBridge(); frame.src = 'about:blank'; dialog.remove(); document.body.style.overflow = overflow; if (trigger.isConnected) trigger.focus(); }, { once: true });
      header.append(title, close); dialog.append(header, frame); document.body.append(dialog);
      document.body.style.overflow = 'hidden'; dialog.showModal(); close.focus();
      emit({ action: 'open', properties: { mode: 'gallery' } });
    }
    button.addEventListener('click', function () { openExperience(button); });
    node.append(button); node.hidden = false;
    var scope = node.closest('[id^="shopify-section"]') || document;
    var image = scope.querySelector('[data-gallery-main]');
    if (image && !scope.querySelector('[data-hd-scale-scene]') && !scope.querySelector('.easel-experience__image-button')) {
      // A sibling of the image-viewer control avoids nested interactive elements.
      var wrapper = document.createElement('div'); wrapper.className = 'easel-experience__image-wrap';
      image.parentNode.insertBefore(wrapper, image); wrapper.append(image);
      var imageButton = document.createElement('button'); imageButton.type = 'button';
      imageButton.className = 'easel-experience__image-button'; labelButton(imageButton);
      imageButton.setAttribute('aria-haspopup', 'dialog');
      imageButton.addEventListener('click', function () { openExperience(imageButton); });
      wrapper.append(imageButton);
    }
  }
  function init() { document.querySelectorAll('[data-easel-handle]').forEach(function (node) {
    if (node.dataset.easelInitialized) return;
    node.dataset.easelInitialized = '1';
    discover(node.dataset.easelHandle).then(function (value) { if (value.available) activate(node, value); }).catch(function () { /* Never interfere with purchasing or cache an outage as a miss. */ });
  }); }
  window.addEventListener('pdp:swapped', init);
  init();
}());
